export function attempt<T, U = undefined>(fn: () => T, fallback?: (err: unknown) => U): T | U {
  try {
    return fn();
  } catch (err) {
    if (fallback) {
      return fallback(err);
    }
  }
  return undefined as U;
}

/**
 * Takes multiple functions as arguments and returns a new function.
 * When the new function is called with a set of arguments, it
 * calls every one of the original functions with those same arguments.
 */
export const chain =
  <TArgs extends unknown[]>(...funcs: ((...args: TArgs) => void)[]) =>
  (...args: TArgs) =>
    funcs.forEach((func) => func(...args));

export const objectHasOwn = (Object.hasOwn ??
  function hasOwn<T extends object>(o: T, v: keyof T) {
    return Object.prototype.hasOwnProperty.call(o, v);
    // oxlint-disable-next-line typescript/no-wrapper-object-types
  }) as <T extends Object>(o: T, v: keyof T) => boolean;

export const objectFromEntries = <const T extends readonly (readonly [PropertyKey, unknown])[]>(
  entries: T,
): { [K in T[number] as K[0]]: K[1] } => Object.fromEntries(entries) as { [K in T[number] as K[0]]: K[1] };

export const objectEntries = <T extends Record<PropertyKey, unknown>>(
  obj: T,
): { [K in keyof T]: [K, T[K]] }[keyof T][] => Object.entries(obj) as { [K in keyof T]: [K, T[K]] }[keyof T][];

/**
 * Creates a sequence of numbers from 0 to length - 1.
 */
export const sequence = (length: number) => Array.from({ length }, (_, i) => i);

export function noop(): void;
export function noop(): undefined;
export function noop() {
  /* empty */
}
